// import useAxios from 'axios-hooks';
import axios from 'axios';
import { store } from '@/store/store';

// console.log(store);

const axiosParams = {
  // Set different base URL based on the environment
  //baseURL: 'https://sistemasmvla.com.ar:8443/municipalidad/ws/municipalidad/',
  baseURL: `${process.env.REACT_APP_MUNICIPALIDAD_FRONT_HOST}/ws/municipalidad`,
};

// Create axios instance with default params
const axiosInstance = axios.create(axiosParams);

axiosInstance.interceptors.request.use(
  async (config) => {
    if (config?.baseURL.includes('openweathermap')) {
      return config;
    }

    const session = store.getState().session;
    if (session?.token) {
      config.headers['Aero-Token'] = session.token.valor;
    }

    // config.headers['Content-Type'] = 'application/json';
    return config;
  },
  (error) => Promise.reject(error),
);

axiosInstance.interceptors.response.use(
  (response) => response,
  async (error) => {
    const { config } = error;

    if (error.response?.status === 401) {
      window.location = '/unauthorized';
      return axios(config);
    }

    if (error.response?.status === 404) {
      window.location = '/notfound';
      return axios(config);
    }

    return Promise.reject(error);
  },
);

// Main api function
const api = (axios) => {
  return {
    get: function (url, config) {
      if (config) {
        return axios.get(url, config);
      } else {
        return axios.get(url);
      }
    },
    post: (url, body) => {
      return axios.post(url, body);
    },
    postFile: (url, body) => {
      return axios.post(url, body, { responseType: 'arraybuffer' });
    },
    delete: (url, body) => {
      return axios.delete(url, body);
    },
  };
};
export default api(axiosInstance);
